import React from "react";
import CoreButton from "./CoreButton";

export default function CoreContainedButton(props) {
  return (
    <CoreButton varient="contained" {...props}>
      {props?.children}
    </CoreButton>
  );
}
